import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { EditionLayer } from '../../models/edition-layer';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {ConfigService} from '../utils/config.service';
import { Router } from '@angular/router';

@Injectable()
export class ConfigParamsService {
  private getConfigURL = `${environment.API}${environment.RESOURCES.CONFIG}`;
  private config = null;
  private specifiedLayerConfig = null;
  private baseLayers: Array<ol.layer.Layer>;
  private editionLayers: Array<EditionLayer>;

  private selectedEditionLayer = new Subject<EditionLayer>();
  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) {
    this.baseLayers = [];
    this.editionLayers = [];
    this.getConfigURL = `${configService.getBaseApiUrl}${environment.RESOURCES.CONFIG}`;
  }

  getConfigFile(type: 'public' | 'privat' | 'global' = 'global'): Promise<Object> {
    const url = this.getConfigURL + `/${type}`;
    return this.http.get(url)
      .toPromise()
      .then(response => {
        if (type === 'global') {
        this.config = response;
      } else {
        this.specifiedLayerConfig = response;
      }
        return response || {};
      })
      .catch(this.handleError);
  }

  getConfig(): Object {
    return this.config;
  }

  getSpecifiedLayerConfig(): Object {
    return this.specifiedLayerConfig;
  }

  pushEditionLayer(editionLayer: EditionLayer) {
    this.editionLayers.push(editionLayer);
  }

  getEditionLayersBy(propertyName, valueForProperty): EditionLayer[] {
    return this.editionLayers.filter(editionLayer => editionLayer[propertyName] === valueForProperty);
  }

  getEditionLayers(): EditionLayer[] {
    return this.editionLayers;
  }

  setSelectedEditionLayer(layer: EditionLayer) {
    this.selectedEditionLayer.next(layer);
  }
  getSelectedEditionLayer(): Observable<any> {
    return this.selectedEditionLayer.asObservable();
  }

  resetEditionLayers(){
    this.editionLayers = []
  }

  public isPrivateApp(): boolean {
    return this.router.url.includes('/privat');
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/configParameters/config-params.service.ts